<template>
  <section class="w-100 bg-purple d-flex align-items-center">
    <div
      class="w-100 bg-color-change d-flex align-items-center head-banners"
      :class="bgColorChange"
    >
      <div id="banners-home">
        <button class="button-arrow button-right" v-on:click="next()">
          <span>&#8250;</span>
        </button>
        <button class="button-arrow button-left" v-on:click="prev()">
          <span>&#8249;</span>
        </button>
        <b-container>
          <b-row>
            <!-- mid -->
            <b-col lg="7" />

            <!-- side right -->
            <b-col cols="12" lg="5">
              <!-- formulário de coleta de lead -->
              <principal-form class="mt-5 mb-head" />
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </section>
</template>

<script>
// all
import FormSellMyVehicle from "@/components/FormSellMyVehicle";

export default {
  components: {
    "principal-form": FormSellMyVehicle,
  },
  data: () => {
    return {
      bgColorChange: "bg-1",
      timeChangeBackground: 7500,
      count: 1,
      maxBg: 3,
    };
  },
  props: {
    topSpace: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.bgColorChange = "bg-1";

    setInterval(() => {
      this.bgColorChange = "bg-" + (this.count + 1);
      this.count++;
      if (this.count === this.maxBg) this.count = 0;
    }, this.timeChangeBackground);
  },
  methods: {
    next() {
      this.bgColorChange = "bg-" + (this.count + 1);
      this.count++;
      if (this.count === this.maxBg) this.count = 0;
    },
    prev() {
      this.count--;
      if (this.count < 0) this.count = 2;
      this.bgColorChange = "bg-" + (this.count + 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.mb-head {
  @media (max-width: 767px) {
    margin-bottom: 85px;
  }

  @media (max-width: 1366px) {
    margin-top: 0 !important;
  }
}

section {
  min-height: 100vh;

  .head-banners {
    min-height: 100vh;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;

    @media (min-width: 768px) and (max-width: 1366px) {
      background-size: 100%;
      margin-bottom: -45px;
    }

    @media (max-width: 767px) {
      background-size: 100%;
      padding-top: 23rem;
      background-position: initial;
    }
  }
}

.bg-1 {
  background-image: url("./../../assets/images/index-header/1-back.jpg");

  @media (max-width: 767px) {
    background-image: url("./../../assets/images/index-header/1-back-mobile.jpg");
  }
}
.bg-2 {
  background-image: url("./../../assets/images/index-header/3-back.jpg");

  @media (max-width: 767px) {
    background-image: url("./../../assets/images/index-header/3-back-mobile.jpg");
  }
}
.bg-3 {
  background-image: url("./../../assets/images/index-header/4-back.jpg");

  @media (max-width: 767px) {
    background-image: url("./../../assets/images/index-header/4-back-mobile.jpg");
  }
}

#banners-home {
  width: 100%;
  position: relative;
  transition: opacity 0.5s linear;

  &:hover .button-arrow {
    opacity: 0.5;
  }

  .button-arrow {
    position: absolute;
    background: transparent;
    top: 50%;
    outline: none;
    z-index: 9;
    border: 2px solid #fff;
    color: #fff;
    width: 40px;
    height: 40px;
    opacity: 0;
    -webkit-transition: all 300ms ease;
    -moz-transition: all 300ms ease;
    -ms-transition: all 300ms ease;
    -o-transition: all 300ms ease;
    transition: all 300ms ease;

    &:hover {
      opacity: 1;
    }

    &.button-right {
      right: 30px;
    }

    &.button-left {
      left: 30px;
    }

    span {
      font-size: 30px;
      position: absolute;
      top: -5px;
      left: 14px;
    }

    @media (max-width: 767px) {
      display: none;
    }
  }
}
</style>
